import { render } from "./AddPaiementPage.vue?vue&type=template&id=b8b4676a&ts=true"
import script from "./AddPaiementPage.vue?vue&type=script&lang=ts"
export * from "./AddPaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__